import { useState } from 'react';
import cards from '~/assets/icons/cards_2.svg';
import { TextInput } from '~/components/ui/TextInput';
import { formatCardNumber } from '~/utils/cardNumber';
import { StyledContainer } from './CardInput.styled';

const CardInput = ({
	value,
	onChange,
	error,
	...props
}: {
	value: string;
	onChange: (value: string) => void;
	error: boolean;
} & Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'>) => {
	const [inputValue, setInputValue] = useState<string>(value);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const raw = e.target.value.replace(/\D/g, '');

		if (raw.length > 16) {
			return;
		}

		if (raw.length === 0) {
			setInputValue('');
		}

		setInputValue(raw);
		onChange(raw);
	};

	return (
		<StyledContainer>
			<TextInput
				height={50}
				fontSize={16}
				active={inputValue.length > 0}
				style={{ paddingLeft: 20, paddingRight: 60 }}
				placeholder={'Введите номер карты'}
				{...props}
				value={formatCardNumber(inputValue)}
				onChange={handleChange}
				error={error}
			/>
			<img src={cards} />
		</StyledContainer>
	);
};

export { CardInput };
